"use client"

import { useQuery } from "@tanstack/react-query"
import { getProductReviews } from "@/actions/product/product.action"
import { getConsultantReviews } from "@/actions/user/user.action"

export const useReviewData = (productId: string, type: "product" | "consultant") => {
  const action = type === "product" ? getProductReviews : getConsultantReviews
  return useQuery({
    queryKey: ["reviews", productId, type],
    queryFn: async () => {
      const res = await action(productId)
      return res.data;
    },
    staleTime: 1,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  })
}
